import React from 'react';
import { selectStockOrderBookData, selectStockOrderBookLoading } from '../../modules/public/stock-order-book/selector';
import { RootState } from '../../modules';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../helpers/formatNumber';
import { OrderBookData } from '../../modules/public/stock-order-book/types';
import { Empty, Spin } from 'antd';
const OrderBook = () => {
    const orderBook = useSelector((state: RootState) => selectStockOrderBookData(state));
    const sellOrders = orderBook?.filter((order) => order.side === 'sell');
    const buyOrders = orderBook?.filter((order) => order.side === 'buy');
    const orderBookloading = useSelector((state: RootState) => selectStockOrderBookLoading(state));
    const renderOrderItem = (order: OrderBookData, side: string) => {
        const remainAmount = Number(order.totalAmount) - Number(order.filledAmount);
        return (
            <div>
                <p className={`desktop-order-book_${side}__other`}>{formatNumber(remainAmount)}</p>
                <p className={`desktop-order-book_${side}__other`}>{Number(order.price).toLocaleString()}</p>
                <p className={`desktop-order-book_${side}__other`}>
                    {formatNumber(Number(order.price) * Number(remainAmount))}
                </p>
                <p className={`desktop-order-book_${side}__side`}>{String(order.side)}</p>
            </div>
        );
    };
    return orderBookloading ? (
        <Spin />
    ) : (
        <div className="desktop-order-book">
            <div className='desktop-order-book_title'>Order Book</div>
            <div className="desktop-order-book_header">
                <p>Amount</p>
                <p>Price(VND)</p>
                <p>Total(VND)</p>
                <p>Side</p>
            </div>
            {sellOrders?.length === 0 ? (
                <div className="desktop-order-book_empty">
                    <Empty />
                </div>
            ) : (
                <div className="desktop-order-book_sell">
                    {sellOrders?.map((order) => {
                        return renderOrderItem(order, 'sell');
                    })}
                </div>
            )}
            {buyOrders?.length === 0 ? (
                <div className="desktop-order-book_empty">
                    <Empty />
                </div>
            ) : (
                <div className="desktop-order-book_buy">
                    {buyOrders?.map((order) => {
                        return renderOrderItem(order, 'buy');
                    })}
                </div>
            )}
        </div>
    );
};

export default OrderBook;
